import styled from 'astroturf/react';
import { PillButton } from 'js/design_system/PillButton';

export const PeriodControlButton = styled(PillButton)`
  background: var(--background-white, #ffffff);
  border: var(--analytics-period-border-width, 1px) solid
    var(--analytics-period-border, var(--stroke-dark, #141413));
  border-radius: var(--border-radius-radius-md, 8px);
  color: var(--analytics-period-text, var(--text-primary, #141413));
  font-size: var(--type-body-md-size, 16px);
  height: 36px;
  line-height: var(--type-body-md-line-height, 20px);
  outline: none;
  padding: 0 var(--spacing-xs-12, 12px);

  &:not(:disabled):hover {
    position: relative;
    z-index: 2;
  }

  &[aria-pressed='true'] {
    background: var(--background-light-blue, #eef2f9);
    border-color: var(--analytics-period-border, var(--text-press, #082f75));
    color: var(--analytics-period-text, var(--text-press, #082f75));
    outline: none;
    position: relative;
    z-index: 1;
  }

  &[aria-pressed='true']:focus-visible {
    outline: 2px solid var(--buttons-button-focus, #0645b1);
    outline-offset: 2px;
  }

  &:not(:disabled):not([aria-pressed='true']):focus:not(:active):not(
      :focus-visible
    ) {
    border: var(--analytics-period-border-width, 1px) solid
      var(--analytics-period-border, var(--stroke-dark, #141413));
    color: var(--analytics-period-text, var(--text-primary, #141413));
    outline: none;

    &:hover {
      outline: 1px solid var(--button-secondary-stroke-hover, #0c3b8d);
    }
  }

  &:disabled {
    background: var(--button-xs-fill, #ffffff);
    border-color: var(
      --analytics-period-disabled-border,
      var(--button-xs-stroke-inactive, #ebebee)
    );
    color: var(
      --analytics-period-disabled-text,
      var(--button-xs-text-inactive, #91919e)
    );
    cursor: not-allowed;
    outline: none;
  }
`;

export const PeriodPopupControls = styled.div`
  --analytics-period-border: var(--button-xs-stroke-inactive, #ebebee);
  --analytics-period-text: var(--text-primary, #141413);
  --analytics-period-disabled-text: var(--button-xs-stroke-inactive, #ebebee);
  --button-secondary-stroke-press: var(--button-xs-stroke-inactive, #ebebee);
  --text-press: var(--text-primary, #141413);

  button:not(:disabled):not([aria-pressed='true']):hover {
    --analytics-period-border: var(--button-xs-stroke-hover, #0c3b8d);
    --analytics-period-text: var(--button-xs-text-hover, #0c3b8d);
    --button-secondary-stroke-hover: var(--button-xs-stroke-hover, #0c3b8d);
    --text-hover: var(--button-xs-text-hover, #0c3b8d);
    background: var(--button-xs-fill-hover, #f4f7fc);
    outline: 1px solid var(--button-xs-stroke-hover, #0c3b8d);
  }
`;

const IconButton = styled(PeriodControlButton)`
  &[aria-label] {
    width: 36px;
    padding: 0;
  }
`;

export const PeriodYearButton = styled(IconButton)`
  --analytics-period-border-width: 0;
  --button-secondary-stroke-press: transparent;
`;

export const PeriodNavigationButton = styled(IconButton)`
  --analytics-period-disabled-border: var(--stroke-dark, #141413);
  --analytics-period-disabled-text: var(--button-xs-stroke-inactive, #ebebee);

  &[data-edge='previous'] {
    border-radius: var(--border-radius-radius-md, 8px) 0 0
      var(--border-radius-radius-md, 8px);
  }

  &[data-edge='next'] {
    margin-left: -1px;
    border-radius: 0 var(--border-radius-radius-md, 8px)
      var(--border-radius-radius-md, 8px) 0;
  }
`;
